import CarePlanMedication from './CarePlanMedication';

export default CarePlanMedication;
